import { FormGroup, FormControl, Validators } from '@angular/forms';
var Tipo_divisionComponent = /** @class */ (function () {
    function Tipo_divisionComponent() {
        this.rows = [];
        this.form = new FormGroup({
            tipo_division1: new FormControl('', Validators.required),
            tipo_division2: new FormControl('', Validators.required),
            tipo_division3: new FormControl('', Validators.required),
        });
        if (!JSON.parse(localStorage.getItem("tipo_division"))) {
            localStorage.setItem("tipo_division", JSON.stringify(this.rows));
        }
        else {
            this.rows = JSON.parse(localStorage.getItem("tipo_division"));
            this.form.controls['tipo_division1'].setValue(this.rows[0] ? this.rows[0].subdivision : 'NO');
            this.form.controls['tipo_division2'].setValue(this.rows[0] ? this.rows[0].fusion : 'NO');
            this.form.controls['tipo_division3'].setValue(this.rows[0] ? this.rows[0].urbanizacion : 'NO');
        }
        this.tipo_division = { subdivision: '', fusion: '', urbanizacion: '' };
    }
    Tipo_divisionComponent.prototype.add_tipo_division = function () {
        localStorage.setItem("tipo_division", JSON.stringify([]));
        this.actualRow = localStorage.getItem("tipo_division");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            'subdivision': this.form.value.tipo_division1,
            'fusion': this.form.value.tipo_division2,
            'urbanizacion': this.form.value.tipo_division3,
        });
        localStorage.setItem("tipo_division", JSON.stringify(this.rows));
    };
    Tipo_divisionComponent.prototype.delete_tipo_division = function (id) {
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("tipo_division", JSON.stringify(this.rows));
            }
        }
    };
    return Tipo_divisionComponent;
}());
export { Tipo_divisionComponent };
